import { useNavigate } from "react-router-dom"
import ImageBox from "./image-box"

const LogoCard = ({ src, path = "/select", customMode = false, children }) => {
  const navigate = useNavigate()

  return (
    <article
      onClick={() => navigate(path)}
      className="bg-white shadow-sm px-6 min-w-70 max-w-100 aspect-17/9 rounded-2xl
                 flex items-center justify-center cursor-pointer
                 hover:shadow-lg hover:scale-105 transition-transform duration-300 ease-in-out"
    >
      {customMode ? (
        children
      ) : (
        <ImageBox className={"w-full h-7/10"} objectFit="contain" src={src} />
      )}
    </article>
  )
}

export default LogoCard
